import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function StrategijskiMenadzment() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Strategijski menadžment" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Strategijski menadžment</h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Strategijski menadžment
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 6
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta je produbljivanje i proširivanje bazičnih
                znanja studenata koja su stekli na predmetima menadžment i
                marketing. Savremeni uslovi poslovanja bilo koje privredne
                organizacije podrazumijevaju veliki dinamizam promjena,
                nestabilnu i promjenjivu poslovnu sredinu u kojoj raste nivo
                konkurentske borbe. Kako bi svojim organizacijama obezbijedili
                opstanak, rast i razvoj i ostvarivanje svih drugih poslovnih
                ciljeva, savremeni menadžeri moraju da razumiju koncept
                strategijskog razmišljanja i djelovanja. Predmet je otuda
                postavljen na bazi paralelnog razvoja dva osnovna stuba
                istraživanja strategijskog menadžmenta – kao koncepta i procesa.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Studenti će nakon odslušanog predmeta moći da definišu viziju i
                misiju preduzeća, postave ciljeve, projektuju alternativne
                strategije i izvrše izbor optimalne strategije. Takođe, studenti
                će biti osposobljeni da implementiraju i kontrolišu sprovođenje
                strategije.
              </p>
              <h3>Sadržaj predmeta</h3>

              <p>
                <strong>Teorijska nastava: </strong>
              </p>
              <ul className="values-section">
                <li>
                  Koncept strategijskog menadžmenta: Pojam, značaj i razvoj
                  strategije kao menadžerske odluke; Strategijski menadžment kao
                  proces; Strategija kao perspektiva; Usmjeravanja organizacija
                </li>
                <li>
                  Analiza eksternog okruženja organizacije: SWOT analiza, PEST
                  analiza, Porterov model pet faktora
                </li>
                <li>
                  Analiza internog okruženja organizacije: Osnovna obilježja
                  analiza internog okruženja, Analiza lanca vrijednosti, Pogled
                  na firmu zasnovan na resursima, Ocjena performansi
                  organizacije
                </li>
                <li>
                  Formulisanje strategije na nivou poslovnih jedinica: Izvori
                  konkurentske prednosti
                </li>
                <li>
                  Formulisanje korporativne strategije na nivou cijele
                  organizacije: Strategije rasta, Ekspanzija kao strategija
                  rasta, Diversifikacija, Portfolio menadžment, Analiza realnih
                  opcija
                </li>
                <li>
                  Formulisanje strategije na međunarodnom nivou: Faktori koji
                  utiču na konkurentnost nacija, Međunarodna ekspanzija,
                  Globalna strategija, Ulazni modeli za međunarodnu ekspanziju
                </li>
                <li>
                  Strategijska implementacija: Efektivni organizacioni dizajn,
                  Strategijsko liderstvo, Inovacije i preduzetništvo
                </li>
                <li>
                  Strategijska kontrola: Tradicionalni pristup strategijskoj
                  kontroli, Savremeni pristup, Uloga korporativnog upravljanja
                </li>
              </ul>

              <p>
                <strong>Metode izvođenja nastave:</strong> Predavanja se izvode
                uz korišćenje prezentacija i dodatna objašnjenja profesora.
                Praktična nastava prati teorijska predavanja uz primjenu
                sledećih važnijih metoda: interaktivni rad, pojedinačne i grupne
                prezentacije, analiza praktičnih slučajeva, simulacija
                različitih uloga.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Koncept strategijskog menadžmenta; Pojam, značaj i razvoj
                      strategije kao menadžerske odluke
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Strategijski menadžment kao proces; Strategija kao
                      perspektiva; Usmjeravanja organizacija
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Analiza eksternog okruženja organizacije: SWOT analiza,
                      PEST analiza
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Porterov model pet faktora; Analiza internog okruženja
                      organizacije
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Osnovna obilježja analiza internog okruženja; Analiza
                      lanca vrijednosti
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Pogled na firmu zasnovan na resursima; Ocjena performansi
                      organizacije
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>Formulisanje strategije na nivou poslovnih jedinica</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>
                      Izvori konkurentske prednosti; Formulisanje korporativne
                      strategije na nivou cijele organizacije
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>Strategije rasta; Ekspanzija kao strategija rasta</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Diversifikacija; Portfolio menadžment; Analiza realnih
                      opcija
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Formulisanje strategije na međunarodnom nivou; Kratak
                      pogled na svjetsku privredu
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Faktori koji utiču na konkurentnost nacija; Međunarodna
                      ekspanzija; Globalna strategija
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Tradicionalni pristup strategijskoj kontroli; Savremeni
                      pristup; Uloga korporativnog upravljanja
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 345 h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 215 h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default StrategijskiMenadzment;
